import { createContext, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ModalBackground, ModalContainer} from "./styles";
import services from '../../services/';
import { setToken, refreshTokenExpirationCheck } from '../../store/actions/auth';
import { RefreshTokenTime } from "../../types/auth.dto";
import { Action, Dispatch } from 'redux';
import Button from "../../components/Button/index";

export const AuthContext = createContext({
  isAuthenticated: false as boolean,
});

const AuthProvider = ({
  children,
  auth,
  authStates
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const [hasValidToken, setHasValidToken] = useState<boolean>(false);
  const [showInactivityModal, setShowInactivityModal] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(RefreshTokenTime.INACTIVITY_CLOSE_MODAL);

  useEffect(() => {
    if(auth !== null) {
      if(authStates.success) {
        dispatch(refreshTokenExpirationCheck());
        setHasValidToken(true);
      }
    } else {
      dispatch(setToken());
    }
  }, [])

  useEffect(() => {
    let inactivityTimer: NodeJS.Timeout;
    const resetTimer = () => {
      clearInterval(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        setShowInactivityModal(true);
      }, RefreshTokenTime.INACTIVITY_MODAL * 60 * 1000);
    };
    const events = ['mousemove', 'keydown', 'click'];
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });
    resetTimer();
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
      clearTimeout(inactivityTimer);
    };
  }, []);

  useEffect(() => {
    let countdownInterval: NodeJS.Timeout;
  
    if (showInactivityModal) {
      countdownInterval = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);
    }

    if (countdown === 0) {
      setShowInactivityModal(false);
      services.auth.signOut();
    }
  
    return () => clearInterval(countdownInterval);
  }, [showInactivityModal, countdown]);

  const handleLogout = () => {
    services.auth.signOut();
  };

  const handleCancel = () => {
    setCountdown(RefreshTokenTime.INACTIVITY_CLOSE_MODAL);
    setShowInactivityModal(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated: hasValidToken }}>
      {children}
      {showInactivityModal && (
        <ModalBackground>
          <ModalContainer>
            <h2>Notamos que no estás presente</h2>
            <p>Tu sesión se cerrará en {Math.floor(countdown / 60)}:{('0' + (countdown % 60)).slice(-2)}</p>
            <div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>
              <Button             options={{
                type: "filled",
                skin: "primary",
                size: "md",
              }} onClick={handleLogout}>OK</Button>
              <Button             options={{
                type: "filled",
                skin: "primary",
                size: "md",
              }} onClick={handleCancel}>Cancelar</Button>
            </div>
          </ModalContainer>
        </ModalBackground>
      )}
    </AuthContext.Provider>
  );
};


const states = ({ authStore }) => {
  const { data: auth, states: authStates } = authStore;

  return {
    auth,
    authStates,
  };
};

export default connect(states)(AuthProvider);

